/* ============================================
   PROPERTYVIEWSCREEN.JSX
   ============================================ */

import React, { useContext, useEffect, useState } from 'react';
import {
  ArrowLeft, Share2, MapPin, Bed, Bath, Droplets, Car, LandPlot,
  Maximize2, CheckCircle2, Sprout, DoorOpen, Users, Waves,
  ArrowUpDown, Building2, Hash, CornerDownRight, RectangleHorizontal,
  Calendar, Eye, MousePointerClick, Clock, Layers, Edit, Star,
  Trash2, Power, ChefHat, Zap, Flame, Wifi
} from 'lucide-react';
import '../../../assets/css/sellers/dashboard/sellerproperty/propertyviewscreen.css';
import { useLocation, useParams } from 'react-router-dom';
import AppContext from 'context/AppContext';
import SellerMasterLayout from 'layouts/SellerMasterLayout';
import Swal from 'sweetalert2';
import axios from 'axios';
import AdminMasterLayout from 'layouts/AdminMasterLayout';

export default function PropertyViewScreen({
  property,
  isAdmin,
  viewFrom,
  onBack,
  onEdit,
  onSold,
  onToggle,
  onDelete,
  setPropertyForEdit
}) {

  const [activeImg, setActiveImg] = useState(0);

  const { Navigate, baseUrlForFiles, baseUrl, authToken } = useContext(AppContext);

  const p = property || {};

  const images =
    p.expropertyimages?.length > 0
      ? p.expropertyimages.map((img) => `${baseUrlForFiles}${img.images}`)
      : p.image
        ? [`${baseUrlForFiles}${p.image}`]
        : ['https://via.placeholder.com/800x500?text=No+Image'];

  const isForSale = p.listingType === 'FOR SALE' || p.listingType === 'Sale';

  const markPropertyStatus = (property) => {
    axios.post(`${baseUrl}/seller/sellerproperties/markPropertyStatus`, {
      id: property.id,
      status: isForSale ? "Sold" : "Rented",
      headers: {
        "Content-Type": "multipart/formdata",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          Swal.fire("Success", "Property marked as sold", "success");
          Navigate('/seller/my-property');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // const openToggleConfirm = (property) => {
  //   console.log('Toggle confirm', property);
  // };
  const changePropertyStatus = (property) => {
    axios.post(`${baseUrl}/seller/sellerproperties/changePropertyStatus`, {
      id: property.id,
      status: property.status === "Active" ? "Deactive" : "Active",
      headers: {
        "Content-Type": "multipart/formdata",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then((response) => {
        if (response.data.success === true) {

          Swal.fire("Success", "Status updated", "success");
          Navigate('/seller/my-property');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // const openDeleteConfirm = (id) => {
  //   console.log('Delete confirm', id);
  // };



  const getStatusColor = (status) => {
    if (status === 'Active') return '#10B981';
    if (status === 'Sold' || status === 'Rented') return '#8b5cf6';
    if (status === 'Pending') return '#d97706';
    return '#EF4444';
  };
  const statusColor = getStatusColor(p.status);

  const featuresList = p.features
    ? (Array.isArray(p.features) ? p.features : p.features.split(','))
      .map((f) => f.trim())
      .filter(Boolean)
    : [];

  // Highlights = boolean amenity fields that are true
  const toBool = (val) => {
    if (typeof val === 'string') return val === '1' || val.toLowerCase() === 'true';
    return Boolean(val);
  };

  const highlightItems = [
    { label: 'Garden', value: toBool(p.garden_available) },
    { label: 'Balcony', value: toBool(p.balcony) },
    { label: 'Servant Quarter', value: toBool(p.servant_quarters) },
    { label: 'Swimming Pool', value: toBool(p.swimming_pool) },
    { label: 'Lift Available', value: toBool(p.lift_available) },
    { label: 'Water Supply', value: !!p.water_source },
    { label: 'Electricity', value: toBool(p.electricity) },
    { label: 'Gas', value: toBool(p.gas) },
  ].filter((item) => item.value);

  const formattedDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
      return new Date(dateStr).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
    } catch {
      return dateStr;
    }
  };
  const Layout = isAdmin
    ? AdminMasterLayout
    : SellerMasterLayout;

  return (
    <>
      <Layout>
        <div className="pvs-page">

          {/* ============ TOP HEADER ============ */}
          <div className="pvs-top-header">
           <button
  className="pvs-back-btn"
  onClick={() => {
    if (onBack) {
      onBack();
    }
  }}
>
  <ArrowLeft size={18} />
  <span>
    {isAdmin ? "Back to Sellers" : "Back to My Properties"}
  </span>
</button>
            {/* <button className="pvs-share-btn">
          <Share2 size={16} />
          <span>Share Property</span>
        </button> */}
          </div>

          {/* ============ MAIN CONTENT GRID ============ */}
          <div className="pvs-content-grid">

            {/* ===================== LEFT COLUMN ===================== */}
            <div className="pvs-left-col">

              {/* --- Image Gallery --- */}
              <div className="pvs-gallery-card">
                <div className="pvs-main-image-wrap">
                  <img
                    src={images[activeImg]}
                    alt={p.property_title}
                    className="pvs-main-image"
                  />
                  <div className="pvs-img-counter">{activeImg + 1} / {images.length}</div>
                </div>
                {images.length > 1 && (
                  <div className="pvs-thumbnails">
                    {images.map((img, i) => (
                      <img
                        key={i}
                        src={img}
                        alt={`thumb-${i}`}
                        className={`pvs-thumb ${activeImg === i ? 'pvs-thumb-active' : ''}`}
                        onClick={() => setActiveImg(i)}
                      />
                    ))}
                  </div>
                )}
              </div>

              {/* --- Title / Price / Quick Stats Card --- */}
              <div className="pvs-info-card">
                <span
                  className="pvs-listing-badge"
                  style={{
                    backgroundColor: isForSale ? 'rgba(16,185,129,0.12)' : 'rgba(23,162,184,0.12)',
                    color: isForSale ? '#10B981' : '#17a2b8',
                  }}
                >
                  {isForSale ? 'FOR SALE' : 'FOR RENT'}
                </span>

                <h1 className="pvs-title">{p.property_title}</h1>

                <div className="pvs-location-row">
                  <MapPin size={15} />
                  <span>{p.location}</span>
                </div>

                <div className="pvs-price">{p.price}</div>
                {p.price_negotiable && <p className="pvs-price-note">Price is Negotiable</p>}

                {/* Quick stat chips */}
                <div className="pvs-quick-stats">
                  {Number(p.bedrooms) > 0 && (
                    <div className="pvs-stat-chip">
                      <Bed size={18} />
                      <span className="pvs-stat-num">{p.bedrooms}</span>
                      <span className="pvs-stat-lbl">Bedrooms</span>
                    </div>
                  )}
                  {Number(p.bathrooms) > 0 && (
                    <div className="pvs-stat-chip">
                      <Bath size={18} />
                      <span className="pvs-stat-num">{p.bathrooms}</span>
                      <span className="pvs-stat-lbl">Bathrooms</span>
                    </div>
                  )}
                  {Number(p.kitchens) > 0 && (
                    <div className="pvs-stat-chip">
                      <ChefHat size={18} />
                      <span className="pvs-stat-num">{p.kitchens}</span>
                      <span className="pvs-stat-lbl">Kitchens</span>
                    </div>
                  )}
                  {Number(p.parking_spaces) > 0 && (
                    <div className="pvs-stat-chip">
                      <Car size={18} />
                      <span className="pvs-stat-num">{p.parking_spaces}</span>
                      <span className="pvs-stat-lbl">Parking</span>
                    </div>
                  )}
                  {p.land_area && (
                    <div className="pvs-stat-chip">
                      <LandPlot size={18} />
                      <span className="pvs-stat-num">{p.land_area}</span>
                      <span className="pvs-stat-lbl">Land Area</span>
                    </div>
                  )}
                  {p.size && (
                    <div className="pvs-stat-chip">
                      <Maximize2 size={18} />
                      <span className="pvs-stat-num">{p.size}</span>
                      <span className="pvs-stat-lbl">Size</span>
                    </div>
                  )}
                </div>
              </div>

              {/* --- Property Specifications --- */}
              <div className="pvs-section-card">
                <h3 className="pvs-section-title">Property Specifications</h3>
                <div className="pvs-specs-grid">
                  {Number(p.bedrooms) > 0 && (
                    <div className="pvs-spec-item">
                      <Bed size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Bedrooms</p>
                        <p className="pvs-spec-value">{p.bedrooms}</p>
                      </div>
                    </div>
                  )}
                  {Number(p.bathrooms) > 0 && (
                    <div className="pvs-spec-item">
                      <Bath size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Bathrooms</p>
                        <p className="pvs-spec-value">{p.bathrooms}</p>
                      </div>
                    </div>
                  )}
                  {Number(p.washrooms) > 0 && (
                    <div className="pvs-spec-item">
                      <Droplets size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Washrooms</p>
                        <p className="pvs-spec-value">{p.washrooms}</p>
                      </div>
                    </div>
                  )}
                  {Number(p.parking_spaces) > 0 && (
                    <div className="pvs-spec-item">
                      <Car size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Parking Spaces</p>
                        <p className="pvs-spec-value">{p.parking_spaces}</p>
                      </div>
                    </div>
                  )}
                  {Number(p.floors) > 0 && (
                    <div className="pvs-spec-item">
                      <Layers size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Floors</p>
                        <p className="pvs-spec-value">{p.floors}</p>
                      </div>
                    </div>
                  )}
                  {p.floor_number && (
                    <div className="pvs-spec-item">
                      <Building2 size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Floor Number</p>
                        <p className="pvs-spec-value">{p.floor_number}</p>
                      </div>
                    </div>
                  )}
                  {p.year_built && (
                    <div className="pvs-spec-item">
                      <Calendar size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Year Built</p>
                        <p className="pvs-spec-value">{p.year_built}</p>
                      </div>
                    </div>
                  )}
                  {p.size && (
                    <div className="pvs-spec-item">
                      <Maximize2 size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Size</p>
                        <p className="pvs-spec-value">{p.size}</p>
                      </div>
                    </div>
                  )}
                  {p.land_area && (
                    <div className="pvs-spec-item">
                      <LandPlot size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Land Area</p>
                        <p className="pvs-spec-value">{p.land_area}</p>
                      </div>
                    </div>
                  )}
                  {Number(p.kitchens) > 0 && (
                    <div className="pvs-spec-item">
                      <ChefHat size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Kitchens</p>
                        <p className="pvs-spec-value">{p.kitchens}</p>
                      </div>
                    </div>
                  )}
                  {p.servant_quarters && (
                    <div className="pvs-spec-item">
                      <Users size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Servant Quarters</p>
                        <p className="pvs-spec-value">{Number(p.servant_quarters) || 1}</p>
                      </div>
                    </div>
                  )}
                  {p.plot_number && (
                    <div className="pvs-spec-item">
                      <Hash size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Plot Number</p>
                        <p className="pvs-spec-value">{p.plot_number}</p>
                      </div>
                    </div>
                  )}
                  {p.corner_plot !== undefined && p.corner_plot !== null && (
                    <div className="pvs-spec-item">
                      <CornerDownRight size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Corner Plot</p>
                        <p className="pvs-spec-value">{p.corner_plot ? 'Yes' : 'No'}</p>
                      </div>
                    </div>
                  )}
                  {p.boundary_wall !== undefined && p.boundary_wall !== null && (
                    <div className="pvs-spec-item">
                      <RectangleHorizontal size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Boundary Wall</p>
                        <p className="pvs-spec-value">{p.boundary_wall ? 'Yes' : 'No'}</p>
                      </div>
                    </div>
                  )}
                  {p.commercial_type && (
                    <div className="pvs-spec-item">
                      <Building2 size={18} className="pvs-spec-icon" />
                      <div>
                        <p className="pvs-spec-label">Commercial Type</p>
                        <p className="pvs-spec-value">{p.commercial_type}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* --- Features & Amenities --- */}
              {/* <div className="pvs-section-card">
                <h3 className="pvs-section-title">Features & Amenities</h3>
                <div className="pvs-amenities-grid">
                  {p.garden_available && (
                    <div className="pvs-amenity-item">
                      <Sprout size={22} />
                      <span>Garden</span>
                    </div>
                  )}
                  {p.balcony && (
                    <div className="pvs-amenity-item">
                      <DoorOpen size={22} />
                      <span>Balcony</span>
                    </div>
                  )}
                  {p.servant_quarters && (
                    <div className="pvs-amenity-item">
                      <Users size={22} />
                      <span>Servant Quarter</span>
                    </div>
                  )}
                  {p.swimming_pool && (
                    <div className="pvs-amenity-item">
                      <Waves size={22} />
                      <span>Swimming Pool</span>
                    </div>
                  )}
                  {p.lift_available && (
                    <div className="pvs-amenity-item">
                      <ArrowUpDown size={22} />
                      <span>Lift Available</span>
                    </div>
                  )}
                  {p.corner_plot && (
                    <div className="pvs-amenity-item">
                      <CornerDownRight size={22} />
                      <span>Corner Plot</span>
                    </div>
                  )}
                  {p.boundary_wall && (
                    <div className="pvs-amenity-item">
                      <RectangleHorizontal size={22} />
                      <span>Boundary Wall</span>
                    </div>
                  )}
                </div>
              </div> */}

              {/* --- Utilities --- */}
              <div className="pvs-section-card">
                <h3 className="pvs-section-title">Utilities</h3>
                <div className="pvs-utilities-grid">
                  {p.water_source && (
                    <div className="pvs-utility-item">
                      <div className="pvs-utility-icon-wrap pvs-utility-blue">
                        <Droplets size={18} />
                      </div>
                      <div>
                        <p className="pvs-utility-label">Water Source</p>
                        <p className="pvs-utility-value">{p.water_source}</p>
                      </div>
                    </div>
                  )}
                  <div className="pvs-utility-item">
                    <div className="pvs-utility-icon-wrap pvs-utility-yellow">
                      <Zap size={18} />
                    </div>
                    <div>
                      <p className="pvs-utility-label">Electricity</p>
                      <p className="pvs-utility-value">{p.electricity ? 'Yes' : 'No'}</p>
                    </div>
                  </div>
                  <div className="pvs-utility-item">
                    <div className="pvs-utility-icon-wrap pvs-utility-orange">
                      <Flame size={18} />
                    </div>
                    <div>
                      <p className="pvs-utility-label">Gas</p>
                      <p className="pvs-utility-value">{p.gas ? 'Yes' : 'No'}</p>
                    </div>
                  </div>
                  {p.internet && (
                    <div className="pvs-utility-item">
                      <div className="pvs-utility-icon-wrap pvs-utility-purple">
                        <Wifi size={18} />
                      </div>
                      <div>
                        <p className="pvs-utility-label">Internet</p>
                        <p className="pvs-utility-value">{p.internet}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* --- Description --- */}
              <div className="pvs-section-card">
                <h3 className="pvs-section-title">Description</h3>
                <p className="pvs-description-text">{p.description}</p>
              </div>

              {/* --- Additional Features (from features field) --- */}
              {featuresList.length > 0 && (
                <div className="pvs-section-card">
                  <h3 className="pvs-section-title">Additional Features</h3>
                  <div className="pvs-features-pills">
                    {featuresList.map((f, i) => (
                      <span key={i} className="pvs-feature-pill">{f}</span>
                    ))}
                  </div>
                </div>
              )}

            </div>
            {/* ===================== /LEFT COLUMN ===================== */}

            {/* ===================== RIGHT COLUMN ===================== */}
            <div className="pvs-right-col">

              {/* --- Property Summary --- */}
              <div className="pvs-side-card">
                <h3 className="pvs-side-title">Property Summary</h3>
                <div className="pvs-side-rows">
                  <div className="pvs-side-row">
                    <span className="pvs-side-label">Property Type</span>
                    <span className="pvs-side-value">{p.property_type}</span>
                  </div>
                  <div className="pvs-side-row">
                    <span className="pvs-side-label">Listing Type</span>
                    <span className="pvs-side-value">{isForSale ? 'For Sale' : 'For Rent'}</span>
                  </div>
                  <div className="pvs-side-row">
                    <span className="pvs-side-label">Status</span>
                    <span
                      className="pvs-side-badge"
                      style={{ backgroundColor: `${statusColor}20`, color: statusColor }}
                    >
                      {p.status}
                    </span>
                  </div>
                  {p.property_stage && (
                    <div className="pvs-side-row">
                      <span className="pvs-side-label">Property Stage</span>
                      <span className="pvs-side-value">{p.property_stage}</span>
                    </div>
                  )}
                  {p.furnished && (
                    <div className="pvs-side-row">
                      <span className="pvs-side-label">Furnished</span>
                      <span className="pvs-side-value">{p.furnished}</span>
                    </div>
                  )}
                  {p.year_built && (
                    <div className="pvs-side-row">
                      <span className="pvs-side-label">Year Built</span>
                      <span className="pvs-side-value">{p.year_built}</span>
                    </div>
                  )}
                  <div className="pvs-side-row">
                    <span className="pvs-side-label">Added On</span>
                    <span className="pvs-side-value">{formattedDate(p.created_at)}</span>
                  </div>
                  <div className="pvs-side-row">
                    <span className="pvs-side-label">Property ID</span>
                    <span className="pvs-side-value">#EX-{p.id}</span>
                  </div>
                </div>
              </div>

              {/* --- Highlights --- */}
              {highlightItems.length > 0 && (
                <div className="pvs-side-card">
                  <h3 className="pvs-side-title">Highlights</h3>
                  <div className="pvs-highlights-grid">
                    {highlightItems.map((item, i) => (
                      <div key={i} className="pvs-highlight-item">
                        <CheckCircle2 size={15} className="pvs-highlight-check" />
                        <span>{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* --- Location --- */}
              <div className="pvs-side-card">
                <h3 className="pvs-side-title">Location</h3>
                <div className="pvs-side-rows">
                  <div className="pvs-side-row">
                    <span className="pvs-side-label">City</span>
                    <span className="pvs-side-value">{p.city}</span>
                  </div>
                  <div className="pvs-side-row">
                    <span className="pvs-side-label">Location</span>
                    <span className="pvs-side-value">{p.location}</span>
                  </div>
                  <div className="pvs-side-row pvs-side-row-block">
                    <span className="pvs-side-label">Full Address</span>
                    <span className="pvs-side-value">{p.full_address}</span>
                  </div>
                  {p.latitude && (
                    <div className="pvs-side-row">
                      <span className="pvs-side-label">Latitude</span>
                      <span className="pvs-side-value">{p.latitude}</span>
                    </div>
                  )}
                  {p.longitude && (
                    <div className="pvs-side-row">
                      <span className="pvs-side-label">Longitude</span>
                      <span className="pvs-side-value">{p.longitude}</span>
                    </div>
                  )}
                </div>

                {p.latitude && p.longitude && (
                  <div className="pvs-map-wrap">
                    <iframe
                      title="property-location"
                      className="pvs-map-frame"
                      loading="lazy"
                      src={`https://maps.google.com/maps?q=${p.latitude},${p.longitude}&z=15&output=embed`}
                    />
                  </div>
                )}
              </div>

              {/* --- Property Statistics --- */}
              <div className="pvs-side-card">
                <h3 className="pvs-side-title">Property Statistics</h3>
                <div className="pvs-stats-rows">
                  <div className="pvs-stats-row">
                    <span className="pvs-stats-label"><Eye size={14} /> Views</span>
                    <span className="pvs-stats-value">{p.views ?? 0}</span>
                  </div>
                  <div className="pvs-stats-row">
                    <span className="pvs-stats-label"><MousePointerClick size={14} /> Clicks</span>
                    <span className="pvs-stats-value">{p.clicks ?? 0}</span>
                  </div>
                  <div className="pvs-stats-row">
                    <span className="pvs-stats-label"><Calendar size={14} /> Listed On</span>
                    <span className="pvs-stats-value">{formattedDate(p.created_at)}</span>
                  </div>
                  <div className="pvs-stats-row">
                    <span className="pvs-stats-label"><Clock size={14} /> Status</span>
                    <span
                      className="pvs-side-badge"
                      style={{ backgroundColor: `${statusColor}20`, color: statusColor }}
                    >
                      {p.status}
                    </span>
                  </div>
                  {p.property_stage && (
                    <div className="pvs-stats-row">
                      <span className="pvs-stats-label"><Layers size={14} /> Property Stage</span>
                      <span className="pvs-stats-value">{p.property_stage}</span>
                    </div>
                  )}
                </div>
              </div>

            </div>
            {/* ===================== /RIGHT COLUMN ===================== */}

          </div>
          {/* ============ /MAIN CONTENT GRID ============ */}

          {/* ============ BOTTOM ACTIONS BAR ============ */}
          <div className="pvs-bottom-actions">

            {/* My Property ke actions */}
            {!isAdmin && (
              <>
                <button
                  className="pvs-btn pvs-btn-sold"
                  onClick={() => markPropertyStatus(p)}
                >
                  <Star size={16} />
                  Mark as {isForSale ? 'Sold' : 'Rented'}
                </button>

                <button
                  className="pvs-btn pvs-btn-toggle"
                  onClick={() => changePropertyStatus(p)}
                >
                  <Power size={16} />
                  {p.status === 'Active' ? 'Deactivate' : 'Activate'}
                </button>
              </>
            )}

            {/* Admin Seller Properties ke actions */}
            {isAdmin && (
              <>
                <button
                  className="pvs-btn pvs-btn-toggle"
                  onClick={() => onToggle && onToggle(p)}
                >
                  <Power size={16} />
                  {p.status === 'Active' ? 'Suspend' : 'Activate'}
                </button>

                <button
                  className="pvs-btn pvs-btn-sold"
                  onClick={() => onSold && onSold(p)}
                >
                  <Star size={16} />
                  Mark as {isForSale ? 'Sold' : 'Rented'}
                </button>

                <button
                  className="pvs-btn pvs-btn-delete"
                  onClick={() => onDelete && onDelete(p)}
                >
                  <Trash2 size={16} />
                  Delete
                </button>
              </>
            )}

          </div>

        </div>
      </Layout>
    </>
  );
}